module.exports = __webpack_public_path__ + "media/images/pc/items/gift/kiribako_detail_02-37a03dc60e2c72c9fce1b164cbdcc1da.jpg";